module.exports = __webpack_public_path__ + "static/media/sculptureQuestion.7a63683b.png";